module.exports = __webpack_public_path__ + "static/media/linux.c399b230.jpg";